import { createContext, CSSProperties, FC, ReactNode, useContext, useMemo } from 'react';

export type TableColumn = {
    key: string;
    head: ReactNode;
    headText?: string;
    footer?: ReactNode;
    footerText?: string;
    sortKey?: string;
    Value: FC<{ index: number }>;
    valueText?: (index: number) => string;
    style?: {
        cell?: CSSProperties;
        head?: CSSProperties;
        footer?: CSSProperties;
    };
    getHtmlAttributes?: (index: number | undefined) => Record<string, unknown | undefined>;
    subColumns?: TableColumn[];
    accentLevel?: number;
    lockAccent?: boolean;
    stickyConfig?: Partial<TableColumn>;
    isHiddenForRender?: boolean;
    isHiddenForTextMode?: boolean;
    isHidden?: boolean;
};

export const TableColumnsContext = createContext<{ data: TableColumn[] }>({
    data: [],
});

export function useTableColumnsContext(showHiddenForRender = false) {
    const { data } = useContext(TableColumnsContext);
    const filteredDataByHidden = useMemo(
        () => data
            .filter(col => !col.isHidden && !col.isHiddenForRender)
            .map(col => ({
                ...col,
                subColumns: col.subColumns?.filter(subCol => !subCol.isHidden && !subCol.isHiddenForRender)
            })),
        [data]
    );
    return {
        data: showHiddenForRender ? data : filteredDataByHidden,
    };
}

export const getMaxDepth = (cols: TableColumn[]): number => {
    if (!cols?.length) return 0;
    return 1 + Math.max(0, ...cols.map(col => getMaxDepth(col.subColumns || [])));
};
